import React from "react";

import { SelectInput, SelectInputProps } from "react-admin";

const BillingMethodSelectInput = (props: SelectInputProps) => {
  return (
    <SelectInput
      choices={[
        { id: "Sepa", name: "Lastschrift" },
        { id: "StandingOrder", name: "Dauerauftrag" },
        { id: "Invoice", name: "Rechnung" },
      ]}
      {...props}
    />
  );
};
export default BillingMethodSelectInput;
